import { invariant } from "@searchui-searchforms/shared/utils";
import { withPlaceholder } from "@/features/fields-grid";
import type { FieldMapperProps } from "@/features/fields-grid";
import { type EventAssertion, type Field, FieldType } from "@/entities/form-metadata";
import { EventGroupDayInput } from "./DayInput";
import { EventGroupMonthInput } from "./MonthInput";
import { EventGroupPlaceInput } from "./PlaceInput";
import { EventGroupYearInput } from "./YearInput";
import { YearRangeInput } from "./YearRangeInput";

export function EventFieldFieldMapper({
    fieldData,
    fieldPath,
    assertion,
    fieldsetLabel,
    inputProperties,
}: FieldMapperProps<EventAssertion>) {
    invariant(fieldData, "Field data is required");
    if (fieldData.fieldType === FieldType.YearRange && assertion === "Year") {
        return (
            <YearRangeInput
                fieldData={fieldData}
                fieldPath={fieldPath}
                fieldsetLabel={fieldsetLabel}
                inputProperties={inputProperties}
            />
        );
    }
    switch (assertion) {
        case "Day":
            return (
                <EventGroupDayInput
                    fieldPath={fieldPath}
                    fieldData={fieldData as Field<EventAssertion>}
                    inputProperties={inputProperties}
                />
            );
        case "Month":
            return (
                <EventGroupMonthInput
                    fieldPath={fieldPath}
                    fieldData={fieldData as Field<EventAssertion>}
                    inputProperties={inputProperties}
                />
            );
        case "Year":
            return (
                <EventGroupYearInput fieldData={fieldData} fieldPath={fieldPath} inputProperties={inputProperties} />
            );
        case "Place":
            return (
                <EventGroupPlaceInput fieldData={fieldData} fieldPath={fieldPath} inputProperties={inputProperties} />
            );
        default:
            // TODO: add here new relic error log
            return null;
    }
}

export const FieldMapper = withPlaceholder(EventFieldFieldMapper);
